/**
 * uxTelemetry.js — Cliente ligero para POST /ux/event.
 * iter.247 · Fase 9 UX Refactor — event tracking del Modo Simple/Avanzado.
 *
 * Uso:
 *   import { logUXEvent } from "../lib/uxTelemetry";
 *   logUXEvent("ui_mode_change", { from: "simple", to: "advanced", source: "topbar" });
 *
 * Diseño:
 *   - Fire-and-forget: nunca lanza (fallo silencioso vía .catch).
 *   - Beacon-first en unload; fetch normal en runtime.
 *   - No requiere await ni try/catch en el sitio de uso.
 */
import api from "./api";

/**
 * Envía un evento UX al backend. Fire-and-forget.
 * @param {"ui_mode_change"|"advblock_toggle"|"onboarding_ui_mode_selected"} eventType
 * @param {object} meta - Datos adicionales (max 12 keys, values str/bool/int/float).
 * @param {object} [opts]
 * @param {string} [opts.page] - Página desde donde se dispara (ej "/app/settings").
 * @param {string} [opts.restaurant_id]
 */
export function logUXEvent(eventType, meta = {}, opts = {}) {
  try {
    const body = {
      event_type: eventType,
      meta: meta || {},
      page: opts.page || (typeof window !== "undefined" ? window.location.pathname : null),
      restaurant_id: opts.restaurant_id || null,
    };
    // Fire-and-forget via api.js (respeta auth + baseURL); errores silenciosos.
    api.request("/ux/event", {
      method: "POST",
      body: JSON.stringify(body),
    }).catch(() => { /* telemetría no debe romper la UI */ });
  } catch {
    /* nunca propagar */
  }
}
